import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { enrutador } from './enrutador';
import { iniciarI18n } from './i18n/configuracion';
import { ProveedorDeSesion } from './sesion/ProveedorDeSesion';
import { aplicarTema, temaGuardado } from './tema/tema';
import './estilos/global.css';

const clienteDeConsultas = new QueryClient({
  defaultOptions: {
    queries: {
      // El mostrador vuelve a la misma pantalla todo el día: revalidar al enfocar molesta
      // más de lo que ayuda. Los datos se refrescan cuando la operación lo pide.
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: 1,
    },
  },
});

async function arrancar(): Promise<void> {
  await iniciarI18n();
  aplicarTema(temaGuardado());

  const contenedor = document.getElementById('raiz');
  if (contenedor === null) {
    throw new Error('Falta el contenedor raíz en el documento');
  }

  createRoot(contenedor).render(
    <StrictMode>
      <QueryClientProvider client={clienteDeConsultas}>
        <ProveedorDeSesion>
          <RouterProvider router={enrutador} />
        </ProveedorDeSesion>
      </QueryClientProvider>
    </StrictMode>,
  );
}

void arrancar();
